// Shim that redirects `@vue/composition-api` (used by vue-editor-js) to
// Vue 2.7's built-in Composition API. We expose:
//   - a default export with a no-op `install` so `Vue.use(VueCompositionApi)`
//     does not blow up (Vue 2.7 already has the API natively),
//   - all named exports (`defineComponent`, `reactive`, `onMounted`, `watch`,
//     etc.) re-exported from `vue` so consumers share the same runtime as
//     the rest of the app and `getCurrentInstance()` works correctly.
export * from 'vue'

export default {
  install() {
    /* no-op: Composition API is built into Vue 2.7 */
  }
}
